<div  [formGroup]="registerForm">
    <label [for]="id">{{label}}</label>
    <input *ngIf="type !== 'password'" [id]="id" [formControlName]="id" type="text" [(ngModel)]="value" pInputText/>
    <p-password *ngIf="type === 'password'" [id]="id" [feedback]="false" [formControlName]="id" [(ngModel)]="value" [toggleMask]="true"></p-password>
</div>